import { render, staticRenderFns } from "./EditTransfers.vue?vue&type=template&id=59d76f2d"
import script from "./EditTransfers.vue?vue&type=script&lang=js"
export * from "./EditTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports